<div class="container">
  <div class="content">
    <h1>404</h1>
    <p>Page not found</p>
    <button mat-raised-button color="primary" routerLink="/">Go to Home</button>
  </div>
</div>
